import { render, staticRenderFns } from "./OpportunityDashboardSummaryCard.vue?vue&type=template&id=4e07ff6a&scoped=true&"
import script from "./OpportunityDashboardSummaryCard.vue?vue&type=script&lang=js&"
export * from "./OpportunityDashboardSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDashboardSummaryCard.vue?vue&type=style&index=0&id=4e07ff6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e07ff6a",
  null
  
)

export default component.exports